import React, { Fragment } from 'react';
import './index.css';

function Button({ article, active, onclick, variant }) {

  const url = `#${article}`;
  let text = '';

  switch (article) {
    case 'administra':
      text = <Fragment>{variant === "adolescentes" ? (<>
        <strong>¡Conocé Más!</strong>
      </>) : (variant === "emprendedora" || variant === "micro") ? (<>
        <strong>Aprendé más</strong>
        </>) : (<>
        <strong>Aprendé más</strong><br />sobre tus <strong>finanzas</strong>
        </>)}</Fragment>;
      break;
    case 'cajero':
      text = <Fragment>Usá el <strong>cajero<br />automático</strong></Fragment>;
      break;
    case 'calendario':
      text = <Fragment>Sumate a los <strong><br />encuentros</strong></Fragment>;
      break;
    case 'contacto':
      text = <Fragment><strong>Canales</strong><br />de <strong>contacto</strong></Fragment>;
      break;
    case 'cuenta-comercios':
        text = <Fragment>{variant === "micro" ? (<>
          <strong>Cuenta DNI Comercios</strong><br />La app de cobros
          </>) : (<>
          Usá <strong>Cuenta DNI<br />Comercios</strong>
          </>)}</Fragment>;
        break;
    case 'cuenta-dni':
      text = <Fragment>Usá <strong>Cuenta DNI</strong><br /> y aprovechá las promos</Fragment>;
      break;
    case 'shorts':
      text = <Fragment><strong>¡Shorts!</strong></Fragment>;
      break;
    case 'finanzas':
      text = <Fragment>Planificá tus <strong>finanzas</strong></Fragment>;
      break;
    case 'homebanking':
      text = <Fragment>Operá desde la compu<br /><strong>Homebanking</strong></Fragment>;
      break;
    case 'impulsa':
      text = <Fragment><strong>Potenciá</strong><br />tu emprendimiento</Fragment>;
      break;
    case 'objetivos':
      text = <Fragment><strong>Programa</strong></Fragment>;
      break;
    case 'seguridad':
      text = <Fragment><strong>Consejos</strong><br />de <strong>Seguridad</strong></Fragment>;
      break;
    case 'productivas':
      text = <Fragment><strong>Mujeres Productivas</strong></Fragment>;
      break;
    case 'tipo-cuenta':
      text = <Fragment><strong>Tipos de Cuentas</strong></Fragment>;
      break;
    case 'medio-pago':
      text = <Fragment><strong>Medios de Pago</strong></Fragment>;
      break;
    case 'presupuesto':
      text = <Fragment><strong>Presupuesto</strong></Fragment>;
      break;
    case 'ahorro':
      text = <Fragment><strong>Ahorro</strong></Fragment>;
      break;
    case 'inversion':
      text = <Fragment><strong>Inversión</strong></Fragment>;
      break;
    case 'canal-digital':
      text = <Fragment><strong>Canales Digitales</strong></Fragment>;
      break;
    default:
      break;
  }
  
  return (
    <button className={`main-button ${article} ${active && 'active'}`} href={url} onClick={onclick}>
      <i></i>
      <span>{text} {active}</span>
    </button>
  );
}

export default Button;